/** Maps app Reparto index → physical department on 3i RT-40
 *  Cassa: 1=4% BENE | 2=10% BENE | 3=22% BENE | 4=22% SERVIZI
 */
const APP_TO_PRINTER = {
  0: 1, // B2B 4%
  1: 3, // Mangimi / sfuso → 22% BENE
  2: 2, // Accessori 10%
  3: 4, // Servizi 22% SERVIZI
  5: 3 // Antiparassitari 22% BENE
}

export const toPrinterReparto = (appReparto) => {
  const rep = Number(appReparto)
  if (rep === 4) return null
  return APP_TO_PRINTER[rep] ?? 3
}

/** Sfuso va sempre su reparto cassa 3 (22% BENE), indipendentemente dal Reparto salvato */
export const resolvePrinterReparto = ({ appReparto, pesoSfuso }) => {
  if (Number(pesoSfuso) > 0) return 3
  return toPrinterReparto(appReparto)
}

export const isBlockedReparto = (appReparto) => Number(appReparto) === 4
